import React, { useContext } from 'react';
import { AppContext } from '../../context/appContext';
import WaitingResponse from './components/WaitingResponse';

const ActionProvider = ({ createChatBotMessage, setState, children }: any) => {
  const {getWebSocket, sendMessage} = useContext(AppContext);

  const sendUserWsMessage = (message: string) => {
    sendMessage(
      JSON.stringify({
        event: 'client_message',
        content: message
      })
    );

    addWaitingMessageToChat();
  }

  getWebSocket().onmessage = (message: any) => {
    if (getWebSocket().readyState === WebSocket.OPEN) {
      const response = JSON.parse(message.data);
      console.log('response', response);
      const messageText = response.message ? (response.message.content ?? '') : '';

      if (response.event != 'connected') {
        const botMessage = createChatBotMessage(
          messageText,
          {
            widget: 'chatForm',
            payload: {
              message: response.message, 
              page: response.page
            }
          }
        );

        setState((prevState: any) => {
          const filteredMessages = prevState.messages.filter((item: any) => !item.waiting);
          return {
            ...prevState,
            messages: [...filteredMessages, botMessage]
          }
        });
      }
    }
  }

  const addWaitingMessageToChat = () => {
    const waitingResponseMessage = createChatBotMessage(
      <WaitingResponse />, "bot"
    )
    
    setState((prevState: any) => {
      const filteredMessages = prevState.messages.filter((item: any) => !item.waiting)
      return {
        ...prevState,
        messages: [...filteredMessages, {...waitingResponseMessage, waiting: true}],
      }
    });
  }

  return (
    <>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          actions: {
            sendUserWsMessage
          },
        });
      })}
    </>
  );
};

export default ActionProvider;
